import { IValidationResult } from "@edaz/services/baseValidationService";

export interface LicensePlateChangeValidatorOptions<TEntity> {
  originalProperty: keyof TEntity;
}

export interface LicensePlateChangeValidatorParams<TEntity> {
  entity: TEntity;
}

export function compareStringsWithIndexes(a: string, b: string) {
  const aArray = Array.from(a);
  const bArray = Array.from(b);
  const differentCharacterIndexes = [] as number[];

  if (aArray.length === bArray.length) {
    aArray.forEach((character, index) => {
      if (bArray[index] !== character) {
        differentCharacterIndexes.push(index);
      }
    });
  }

  return differentCharacterIndexes;
}

export function licensePlateChangeValidator<TEntity>(
  value: string,
  options?: LicensePlateChangeValidatorOptions<TEntity>,
  params?: LicensePlateChangeValidatorParams<TEntity>
): IValidationResult {
  const entity: TEntity = params?.entity!;
  const originalLicensePlate = `${entity[options?.originalProperty!]}`;

  const sameLength = originalLicensePlate.length === value.length;
  const differentCharacters = compareStringsWithIndexes(originalLicensePlate, value);

  if (!sameLength || differentCharacters.length > 2) {
    return {
      isValid: false,
      errors: {
        value: value,
        constraints: {
          invalidLicensePlateChange: "false",
        },
      },
    };
  }

  return {
    isValid: true,
  };
}
